import { takeLatest } from "redux-saga/effects";

import * as actions from "../../actions";
import { selectMenuSaga } from "./layout";

export function* watchLayoutSaga() {
  yield takeLatest(actions.onSelectMenu.type, selectMenuSaga);
}
